(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["archived-events"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-archived-events')) {
  customElements.define('spaces-archived-events', class extends HTMLElement {
    #currentFilters = {};
    #endCursor = null;

    static get observedAttributes() {
      return ['filters'];
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }

      this.shadowRoot?.querySelector('spaces-event-collection')
        ?.addEventListener('loadmore', () => this.#fetchMore());
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'filters') {
        try {
          const filters = newValue ? JSON.parse(newValue) : {};
          this.#onFiltersChanged(filters);
        } catch (e) {
          console.error('Invalid JSON in filters attribute:', e);
        }
      }
    }

    #onFiltersChanged(filters) {
      this.#currentFilters = filters;
      this.#endCursor = null;
      this.#fetchEvents(filters);
    }

    #buildUrl(filters) {
      const apiEndpoint = this.getAttribute('api-endpoint');
      if (!apiEndpoint) return null;

      const url = new URL(`${apiEndpoint}/events`);

      if (filters.space) url.searchParams.set('space', filters.space);
      if (filters.type) url.searchParams.set('type', filters.type);

      url.searchParams.set('before', new Date().toISOString().split('T')[0]);

      url.searchParams.set('photos', 'true');
      url.searchParams.set('limit', '10');
      return url;
    }

    #fetchEvents(filters) {
      const collection = this.shadowRoot?.querySelector('spaces-event-collection');
      if (!collection || typeof collection.load !== 'function') return;

      const url = this.#buildUrl(filters);
      if (!url) return;

      const fetchPromise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`API error: ${res.status}`);
          return res.json();
        })
        .catch(error => {
          console.error('Failed to fetch events:', error);
          return { events: [], spaces: [], pageInfo: {} };
        });

      collection.load(fetchPromise).then(data => {
        if (this.#currentFilters !== filters) return;

        this.#endCursor = data?.pageInfo?.endCursor || null;
        if (data?.pageInfo?.hasNextPage) {
          collection.showLoadMore();
        }

        const emptyEl = this.shadowRoot?.querySelector('.empty');
        if (emptyEl) {
          emptyEl.classList.toggle('hidden', data?.events?.length > 0);
        }
      });
    }

    #fetchMore() {
      if (!this.#endCursor) return;

      const collection = this.shadowRoot?.querySelector('spaces-event-collection');
      if (!collection || typeof collection.append !== 'function') return;

      const url = this.#buildUrl(this.#currentFilters);
      if (!url) return;
      url.searchParams.set('cursor', this.#endCursor);

      collection.hideLoadMore();

      const fetchPromise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`API error: ${res.status}`);
          return res.json();
        })
        .catch(error => {
          console.error('Failed to fetch more events:', error);
          return { events: [], spaces: [], pageInfo: {} };
        });

      collection.append(fetchPromise).then(data => {
        this.#endCursor = data?.pageInfo?.endCursor || null;
        if (data?.pageInfo?.hasNextPage) {
          collection.showLoadMore();
        }
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-badge')) {
  customElements.define('spaces-badge', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-button')) {
  customElements.define('spaces-button', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["callout"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-callout')) {
  customElements.define('spaces-callout', class extends HTMLElement{
    connectedCallback() {

      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
      
      // Only wrap first sentence if highlight-first-sentence attribute is present
      if (!this.hasAttribute('highlight-first-sentence')) return;
      
      const shadowRoot = this.shadowRoot;
      const p = shadowRoot.querySelector('p');
      
      if (!p) return;
      
      const text = p.textContent;
      
      // Find the first sentence (ending with . ! or ? followed by space or end of string)
      const sentenceMatch = text.match(/^([^.!?]+[.!?])(\s+|$)/);
      
      if (sentenceMatch) {
        const firstSentence = sentenceMatch[1];
        const restOfText = text.slice(firstSentence.length);
        // Replace the p content with span + rest of text
        p.innerHTML = `<span class="highlight">${firstSentence}</span>${restOfText}`;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["content-card"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-content-card')) {
  customElements.define('spaces-content-card', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-collection"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-event-collection')) {
  customElements.define('spaces-event-collection', class extends HTMLElement {
    #loadId = 0;
    #events = [];
    #spacesMap = {};
    #grid;
    #empty;
    #controls;
    #loadMoreEl;
    #paginationContainer;
    #handleScroll;
    #resizeObserver;
    #activeTransition;

    get #layout() {
      return this.getAttribute('layout') || 'scroll';
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }

      const sr = this.shadowRoot;
      if (!sr) return;

      this.#grid = sr.querySelector('.grid');
      this.#empty = sr.querySelector('.empty');
      this.#controls = sr.querySelector('.controls');
      this.#loadMoreEl = sr.querySelector('.load-more');
      this.#paginationContainer = sr.querySelector('.pagination');

      this.#loadMoreEl?.querySelector('button')?.addEventListener('click', () => {
        this.dispatchEvent(new CustomEvent('loadmore'));
      });

      if (this.#layout === 'scroll') {
        this.#setupScrollListeners();
      }
    }

    disconnectedCallback() {
      if (this.#grid && this.#handleScroll) {
        this.#grid.removeEventListener('scroll', this.#handleScroll);
      }
      if (this.#resizeObserver) {
        this.#resizeObserver.disconnect();
      }
    }

    // ── Public API ──────────────────────────────────────────────────────────

    /**
     * Load events, replacing any existing content.
     * Accepts a plain { events, spaces } object or a Promise that resolves to one.
     * Shows a loading skeleton while the promise is pending.
     * Stale responses (from rapid calls) are automatically ignored.
     */
    async load(dataOrPromise) {
      const loadId = ++this.#loadId;
      this.#events = [];
      this.hideLoadMore();
      this.#showLoading();

      try {
        const data = await Promise.resolve(dataOrPromise);
        if (loadId !== this.#loadId) return data;

        // Wait for the loading transition to finish before rendering results,
        // so the two view transitions don't overlap and fight.
        if (this.#activeTransition) {
          try { await this.#activeTransition.finished; } catch {}
        }
        if (loadId !== this.#loadId) return data;

        if (data.spaces) this.#updateSpaces(data.spaces);
        this.#events = data.events || [];
        this.#renderEvents();

        // When there ARE events, wait for the render transition so callers
        // don't act while cards are still animating in.
        // When empty, resolve immediately so callers can show their own
        // empty-state UI in sync with the outgoing skeleton crossfade.
        if (this.#events.length > 0 && this.#activeTransition) {
          try { await this.#activeTransition.finished; } catch {}
        }

        return data;
      } catch (error) {
        if (loadId !== this.#loadId) return;
        console.error('Failed to load events:', error);
        this.#events = [];
        this.#renderEvents();
      }
    }

    /**
     * Append additional events to the existing collection.
     * Accepts a plain { events, spaces } object or a Promise that resolves to one.
     * Adds new cards to the grid without clearing existing content.
     */
    async append(dataOrPromise) {
      const data = await Promise.resolve(dataOrPromise);

      if (data.spaces) this.#updateSpaces(data.spaces);
      const newEvents = data.events || [];
      this.#events = [...this.#events, ...newEvents];

      if (this.#grid) {
        for (const event of newEvents) {
          const item = document.createElement('div');
          item.className = 'item';
          item.appendChild(this.#createCardElement(event));
          this.#grid.appendChild(item);
        }
      }

      return data;
    }

    /**
     * Clear all events and cancel any in-flight loads.
     */
    clear() {
      this.#loadId++;
      this.#events = [];
      this.#renderEvents();
    }

    /**
     * Show the "Load more" button below the event list.
     */
    showLoadMore() {
      this.#loadMoreEl?.classList.remove('hidden');
    }

    /**
     * Hide the "Load more" button.
     */
    hideLoadMore() {
      this.#loadMoreEl?.classList.add('hidden');
    }

    // ── Private ─────────────────────────────────────────────────────────────

    #updateSpaces(spaces) {
      for (const space of spaces) {
        this.#spacesMap[space.handle] = space;
      }
    }

    #swapContent(updateFn) {
      if (document.startViewTransition) {
        this.#activeTransition = document.startViewTransition(() => updateFn());
      } else {
        updateFn();
        this.#activeTransition = null;
      }
    }

    #showLoading() {
      if (!this.#grid) return;

      this.#swapContent(() => {
        this.#empty.classList.add('hidden');
        if (this.#controls) this.#controls.classList.add('hidden');
        this.#grid.innerHTML = '';
        const count = this.#layout === 'grid' ? 6 : this.#layout === 'stack' ? 3 : 5;
        for (let i = 0; i < count; i++) {
          const item = document.createElement('div');
          item.className = 'item';
          item.appendChild(document.createElement(this.#cardTag));
          this.#grid.appendChild(item);
        }
      });
    }

    #renderEvents() {
      if (!this.#grid) return;

      this.#swapContent(() => {
        this.#grid.innerHTML = '';

        if (this.#events.length === 0) {
          this.#empty.classList.remove('hidden');
          if (this.#controls) this.#controls.classList.add('hidden');
          return;
        }

        this.#empty.classList.add('hidden');

        for (const event of this.#events) {
          const item = document.createElement('div');
          item.className = 'item';
          item.appendChild(this.#createCardElement(event));
          this.#grid.appendChild(item);
        }

        if (this.#layout === 'scroll') {
          this.#grid.scrollTo({ left: 0 });
          this.#updatePagination();
        }
      });
    }

    get #cardTag() {
      return this.getAttribute('card') || 'spaces-event-card';
    }

    #createCardElement(event) {
      const card = document.createElement(this.#cardTag);
      const space = this.#spacesMap[event.space] || {};

      card.setAttribute('title', event.title || '');
      card.setAttribute('start-date', event.startDate || '');
      card.setAttribute('end-date', event.endDate || '');
      card.setAttribute('type', event.type || 'Community');
      card.setAttribute('rsvp-link', event.rsvpLink || '');
      card.setAttribute('space', event.space || '');
      card.setAttribute('space-label', space.label || '');
      card.setAttribute('space-color', space.color || '#44A1FF');

      if (event.image?.url) {
        card.setAttribute('image-url', event.image.url);
        card.setAttribute('image-alt', event.image.altText || '');
      }

      if (event.badge && event.badge !== 'None') {
        card.setAttribute('badge', event.badge);
      }

      if (event.featuredPhotos?.length) {
        const photoUrls = event.featuredPhotos.map(p => {
          const raw = typeof p === 'string' ? p : p.url;
          try {
            const u = new URL(raw);
            u.searchParams.set('width', '700');
            return u.toString();
          } catch { return raw; }
        });
        card.setAttribute('featured-photos', JSON.stringify(photoUrls));
      }

      return card;
    }

    // ── Scroll pagination ───────────────────────────────────────────────────

    get #itemWidth() {
      const first = this.#grid?.querySelector('.item');
      return first ? first.offsetWidth : 340;
    }

    #setupScrollListeners() {
      const grid = this.#grid;
      if (!grid) return;

      let rafId;
      this.#handleScroll = () => {
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => this.#updatePagination());
      };
      grid.addEventListener('scroll', this.#handleScroll);

      const prevBtn = this.shadowRoot.querySelector('.nav-prev');
      const nextBtn = this.shadowRoot.querySelector('.nav-next');
      if (prevBtn) prevBtn.addEventListener('click', () => this.#scroll(-1));
      if (nextBtn) nextBtn.addEventListener('click', () => this.#scroll(1));

      this.#resizeObserver = new ResizeObserver(() => this.#updatePagination());
      this.#resizeObserver.observe(grid);
    }

    #updatePagination() {
      const grid = this.#grid;
      if (!grid || !this.#controls) return;

      const items = grid.querySelectorAll('.item');
      if (items.length === 0) {
        this.#controls.classList.add('hidden');
        return;
      }

      const itemWidth = this.#itemWidth;
      const itemsPerPage = Math.floor(grid.clientWidth / itemWidth) || 1;
      const totalPages = Math.max(1, items.length - itemsPerPage + 1);

      const scrollLeft = grid.scrollLeft;
      const maxScroll = grid.scrollWidth - grid.clientWidth;
      const atEnd = scrollLeft >= maxScroll - 2;
      const currentPage = atEnd
        ? totalPages - 1
        : Math.min(Math.round(scrollLeft / itemWidth), totalPages - 1);

      const prevBtn = this.shadowRoot.querySelector('.nav-prev');
      const nextBtn = this.shadowRoot.querySelector('.nav-next');
      if (prevBtn) prevBtn.disabled = scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = atEnd;

      // Rebuild dots only when the count changes; otherwise just toggle .active
      const dots = this.#paginationContainer;
      if (dots) {
        if (dots.children.length !== totalPages) {
          dots.innerHTML = '';
          for (let i = 0; i < totalPages; i++) {
            const dot = document.createElement('div');
            dot.className = 'pagination-dot';
            dots.appendChild(dot);
          }
        }
        for (let i = 0; i < dots.children.length; i++) {
          dots.children[i].classList.toggle('active', i === currentPage);
        }
      }

      this.#controls.classList.toggle('hidden', totalPages <= 1);
    }

    #scroll(direction) {
      const grid = this.#grid;
      if (!grid) return;

      const itemWidth = this.#itemWidth;
      const remainder = grid.scrollLeft % itemWidth;

      grid.scrollBy({
        left: direction < 0
          ? -(remainder > 0 ? remainder : itemWidth)
          : itemWidth,
        behavior: 'smooth'
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-filters-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-event-filters-strip')) {
  customElements.define('spaces-event-filters-strip', class extends HTMLElement {
    activeFilters = {};

    handleFilterClick = (event) => {
      const li = event.target.closest('li');
      if (!li) return;
      this.toggleFilter(li);
    }
    
    getFilteredElement() {
      const root = this.getRootNode();
      return root instanceof ShadowRoot ? root.host : this.closest('[accepts-filters]');
    }


    toggleFilter(liElement) {
      const ulElement = liElement.closest('ul[data-filter]');
      if (!ulElement) return;

      const filterType = ulElement.dataset.filter;
      const filterValue = liElement.dataset.filterValue;
      if (!filterType || !filterValue) return;

      ulElement.querySelectorAll('li').forEach(li => {
        li.classList.remove('selected');
      });

      this.activeFilters[filterType] = filterValue;
      liElement.classList.add('selected');

      this.update();
    }

    update() {
      const filteredElement = this.getFilteredElement();
      if (filteredElement) {
        filteredElement.setAttribute('filters', JSON.stringify(this.activeFilters));
      }
    }

    connectedCallback() {
      // Set CSS custom property for filter color on each li element
      this.shadowRoot?.querySelectorAll('li[data-filter-color]').forEach(li => {
        const filterColor = li.dataset.filterColor;
        if (filterColor) {
          li.style.setProperty('--filter-color', filterColor);
        }
      });
      
      this.shadowRoot?.querySelector('.collapsible')?.addEventListener('click', this.handleFilterClick);
      this.toggleFilter(this.shadowRoot?.querySelector('ul[data-filter="space"] li:first-child'));
      this.update();
    }

    disconnectedCallback() {
      this.shadowRoot?.querySelector('.collapsible')?.removeEventListener('click', this.handleFilterClick);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["event-filters"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-event-filters')) {
  customElements.define('spaces-event-filters', class extends HTMLElement {

    activeFilters = {};

    handleExpandClick = () => {
      this.shadowRoot?.querySelector('.filters')?.classList.toggle('expanded');
      this.shadowRoot?.querySelector('.expand')?.classList.toggle('expanded');
    }

    handleFilterClick = (event) => {
      const li = event.target.closest('li');
      if (!li) return;
      this.toggleFilter(li);
    }
    
    getFilteredElement() {
      const root = this.getRootNode();
      return root instanceof ShadowRoot ? root.host : this.closest('[accepts-filters]');
    }

    clearFilters = () => {
      this.activeFilters = {};
      this.shadowRoot?.querySelectorAll('ul li').forEach(li => {
        li.classList.remove('selected');
      });
      this.update();
    }

    toggleFilter(liElement) {
      const ulElement = liElement.closest('ul[data-filter]');
      if (!ulElement) return;

      const filterType = ulElement.dataset.filter;
      const filterValue = liElement.dataset.filterValue;
      if (!filterType || !filterValue) return;

      ulElement.querySelectorAll('li').forEach(li => {
        li.classList.remove('selected');
      });

      if (this.activeFilters[filterType] === filterValue) {
        delete this.activeFilters[filterType];
      } else {
        this.activeFilters[filterType] = filterValue;
        liElement.classList.add('selected');
      }

      this.update();
    }

    update() {
      const clearButton = this.shadowRoot?.querySelector('.filter-footer button');
      if (clearButton) {
        clearButton.disabled = Object.keys(this.activeFilters).length === 0;
      }

      const filteredElement = this.getFilteredElement();
      if (filteredElement) {
        filteredElement.setAttribute('filters', JSON.stringify(this.activeFilters));
      }
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
      
      this.shadowRoot?.querySelector('.filter-header')?.addEventListener('click', this.handleExpandClick);
      this.shadowRoot?.querySelector('.collapsible')?.addEventListener('click', this.handleFilterClick);
      this.shadowRoot?.querySelector('.filter-footer button')?.addEventListener('click', this.clearFilters);

      // Check for space URL parameter and pre-select if present
      const urlParams = new URLSearchParams(window.location.search);
      const spaceParam = urlParams.get('space');
      if (spaceParam) {
        const spaceFilter = this.shadowRoot?.querySelector(`ul[data-filter="space"] li[data-filter-value="${spaceParam}"]`);
        if (spaceFilter) {
          this.toggleFilter(spaceFilter);
        }
      }

      this.update();
    }

    disconnectedCallback() {
      this.shadowRoot?.querySelector('.filter-header')?.removeEventListener('click', this.handleExpandClick);
      this.shadowRoot?.querySelector('.collapsible')?.removeEventListener('click', this.handleFilterClick);
      this.shadowRoot?.querySelector('.filter-footer button')?.removeEventListener('click', this.clearFilters);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["host-with-us"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-host-with-us')) {
  customElements.define('spaces-host-with-us', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marquee-image"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-marquee-image')) {
  customElements.define('spaces-marquee-image', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marquee-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('marquee-quote')) {
    customElements.define('marquee-quote', class extends HTMLElement {
      connectedCallback() {
        if (!this.shadowRoot) {
          loadTemplateToShadowRoot(this);
        }
        if (!this.shadowRoot) return;
        this.quoteElement = this.shadowRoot.querySelector('.marquee-quote');
        this.attributionElement = this.shadowRoot.querySelector('.marquee-quote-attribution');
        if (this.quoteElement) {
          this.quoteElement.innerHTML = this.ensureQuotationMarks();
        }
        if (this.attributionElement) {
          this.attributionElement.innerHTML = this.ensureAttributionEmDashPrefix();
        }
      }

      ensureQuotationMarks() {
        if (this.quoteElement?.textContent) {
          let text = this.quoteElement.textContent.trim();
          text = text.replace(/^["“”]+/, '').replace(/["“”]+$/, '');
          return `“${text}”`;
        }
      }

      ensureAttributionEmDashPrefix() {
        if (this.attributionElement?.textContent) {
          let text = this.attributionElement.textContent.trim();
          if (!/^[a-zA-Z0-9]$/.test(text)) {
            return `— ${text}`;
          }
          return text;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["marquee-text"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-marquee-text')) {
  customElements.define('spaces-marquee-text', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
};
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["round-nav"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-round-nav')) {
  customElements.define('spaces-round-nav', class extends HTMLElement {
    clickHandler = (event) => {
      event.preventDefault();
      event.stopPropagation();
      const target = this.getAttribute('target');
      if (!target) return;
      
      if (target.startsWith('#')) {
        const element = document.getElementById(target.split('#')[1]);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
          return;
        }
      } else {
        window.location.href = target;
      }
    }

    connectedCallback() {
      // Handle both declarative and programmatic Shadow DOM
      if (!this.shadowRoot && typeof loadTemplateToShadowRoot === 'function') {
        loadTemplateToShadowRoot(this);
      }
      
      // Always attach event listener (works with both Shadow DOM types)
      this.addEventListener('click', this.clickHandler);
    }
    
    disconnectedCallback() {
      this.removeEventListener('click', this.clickHandler);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["space-content"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-details')) {
  customElements.define('spaces-details', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["space-title"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-details-title')) {
  customElements.define('spaces-details-title', class extends HTMLElement {
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscribe-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscribe-form')) {
    customElements.define(
      'subscribe-form',
      class extends HTMLElement {

        static MOZART_ENDPOINT = 'https://marketing.preferences.shopify.com/public/subscriptions/';

        constructor() {
          super();
        }

        connectedCallback() {
          if (!this.shadowRoot) {
            loadTemplateToShadowRoot(this);
          }
          this.initialize();
        }

        async subscribeToLocation(subscriptionId, data) {
          const res = await fetch(
            `${this.constructor.MOZART_ENDPOINT}${subscriptionId}.json`,
            {
              method: 'POST',
              body: data,
            },
          );
          if (!res.ok) throw new Error('Subscription failed');
          return res.json();
        }

        async submitForm(form) {

          const data = new FormData();
          const locationCheckboxes = form.querySelectorAll('input[type="checkbox"]');
          const successMessage = this.shadowRoot?.querySelector('.success-message');
          const errorMessage = this.shadowRoot?.querySelector('.error-message');
          const submitButton = this.shadowRoot?.querySelector('button');

          submitButton.disabled = true;
          const checkedIds = new Set([...locationCheckboxes].filter(cb => cb.checked).map(cb => cb.value));

          // Add email to data
          data.append('email', form.querySelector('input[type="email"]').value);

          // Subscribe to each location
          try {
            await Promise.all(
              [...checkedIds].map(subscriptionId => this.subscribeToLocation(subscriptionId, data))
            );
            successMessage.classList.remove('hidden');
          } catch (err) {
            errorMessage.textContent = 'Failed to subscribe. Please try again later.';
            errorMessage.classList.remove('hidden');
          } finally {
            submitButton.disabled = false;
          }
        }

        initialize() {
          const form = this.shadowRoot?.querySelector('form');
          if (!form) return;

          const locationCheckboxes = form.querySelectorAll('input[type="checkbox"]');
          const successMessage = this.shadowRoot?.querySelector('.success-message');
          const errorMessage = this.shadowRoot?.querySelector('.error-message');

          form.addEventListener('submit', (e) => {

            e.preventDefault();
            successMessage.classList.add('hidden');
            errorMessage.classList.add('hidden');

            const isAnyChecked = Array.from(locationCheckboxes).some((cb) => cb.checked);

            if (!isAnyChecked) {
              errorMessage.classList.remove('hidden');
              errorMessage.textContent = 'Please select at least one location.';
            } else {
              this.submitForm(form);
            }
          });

          locationCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('change', () => {
              errorMessage.classList.add('hidden');
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["subscribe-modal-trigger"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('subscribe-modal-trigger')) {
  customElements.define('subscribe-modal-trigger', class extends HTMLElement {
    constructor() {
      super();
      this.triggerButton = null;
      this.modalId = null;
    }

    connectedCallback() {
      if (!this.shadowRoot) return;

      this.triggerButton = this.shadowRoot.querySelector('.trigger-button');
      this.modalId = this.dataset.modalId;

      if (!this.triggerButton || !this.modalId) {
        return;
      }

      this.triggerButton.addEventListener('click', () => {
        // Dispatch custom event to open the modal
        document.dispatchEvent(new CustomEvent('modal:open', {
          detail: { modalId: this.modalId }
        }));
      });

      // Auto-trigger modal if #newsletter is in the URL
      if (window.location.hash === '#newsletter') {
        // Small delay to ensure modal component is ready
        requestAnimationFrame(() => {
          document.dispatchEvent(new CustomEvent('modal:open', {
            detail: { modalId: this.modalId }
          }));
        });
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tag"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-tag')) {
  customElements.define('spaces-tag', class extends HTMLElement {

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["title"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-title')) {
  customElements.define('spaces-title', class extends HTMLElement{
    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upcoming-events-strip"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-upcoming-events-strip')) {
  customElements.define('spaces-upcoming-events-strip', class extends HTMLElement {
    #currentSpace;

    static get observedAttributes() {
      return ['filters'];
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'filters' && newValue) {
        try {
          this.#onFiltersChanged(JSON.parse(newValue));
        } catch (e) {
          console.error('Invalid JSON in filters attribute:', e);
        }
      }
    }

    #onFiltersChanged(filters) {
      this.#fetchEvents(filters);
      this.#updateSubscribeForm(filters.space);
    }

    #fetchEvents(filters) {
      const collection = this.shadowRoot?.querySelector('spaces-event-collection');
      if (!collection || typeof collection.load !== 'function') return;

      const apiEndpoint = this.getAttribute('api-endpoint');
      if (!apiEndpoint) return;

      // Track the current space to ignore stale responses from rapid tab switching
      this.#currentSpace = filters.space;

      const url = new URL(`${apiEndpoint}/events`);
      if (filters.space) url.searchParams.set('space', filters.space);

      // Only show upcoming events (today onwards), capped at 6 for the strip
      const now = new Date().toISOString().split('T')[0];
      url.searchParams.set('after', now);
      url.searchParams.set('limit', '6');

      const fetchPromise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`API error: ${res.status}`);
          return res.json();
        })
        .catch(error => {
          console.error('Failed to fetch events:', error);
          return { events: [], spaces: [] };
        });

      // Start the load first — this synchronously triggers the view transition
      // callback which adds skeletons to the DOM. Then hide the empty state.
      // Both changes land in the same paint frame, avoiding a layout shift.
      const emptyEl = this.shadowRoot?.querySelector('.empty');
      const loadPromise = collection.load(fetchPromise);
      if (emptyEl) emptyEl.classList.add('hidden');

      loadPromise.then(data => {
        // Ignore stale responses — a newer tab switch has already taken over
        if (this.#currentSpace !== filters.space) return;

        const isEmpty = !data?.events?.length;
        if (emptyEl) {
          emptyEl.classList.toggle('hidden', !isEmpty);
        }
      });
    }

    #updateSubscribeForm(spaceFilter) {
      // Forms are in light DOM (slotted), so query from this element
      const allForms = this.querySelectorAll('.subscribe-form-wrapper');
      allForms.forEach(form => {
        form.style.display = 'none';
      });

      if (spaceFilter) {
        const activeForm = this.querySelector(`.subscribe-form-wrapper[data-space-filter="${spaceFilter}"]`);
        if (activeForm) {
          activeForm.style.display = 'block';
        }
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["upcoming-events"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-upcoming-events')) {
  customElements.define('spaces-upcoming-events', class extends HTMLElement {
    #currentFilters = {};
    #endCursor = null;

    static get observedAttributes() {
      return ['filters'];
    }

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }

      this.shadowRoot?.querySelector('spaces-event-collection')
        ?.addEventListener('loadmore', () => this.#fetchMore());
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'filters') {
        try {
          const filters = newValue ? JSON.parse(newValue) : {};
          this.#onFiltersChanged(filters);
        } catch (e) {
          console.error('Invalid JSON in filters attribute:', e);
        }
      }
    }

    #onFiltersChanged(filters) {
      this.#currentFilters = filters;
      this.#endCursor = null;
      this.#hideSubscribeForms();
      this.#fetchEvents(filters);
    }

    #buildUrl(filters) {
      const apiEndpoint = this.getAttribute('api-endpoint');
      if (!apiEndpoint) return null;

      const url = new URL(`${apiEndpoint}/events`);

      if (filters.space) url.searchParams.set('space', filters.space);
      if (filters.type) url.searchParams.set('type', filters.type);

      url.searchParams.set('after', new Date().toISOString().split('T')[0]);

      url.searchParams.set('limit', '10');
      return url;
    }

    #fetchEvents(filters) {
      const collection = this.shadowRoot?.querySelector('spaces-event-collection');
      if (!collection || typeof collection.load !== 'function') return;

      const url = this.#buildUrl(filters);
      if (!url) return;

      const fetchPromise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`API error: ${res.status}`);
          return res.json();
        })
        .catch(error => {
          console.error('Failed to fetch events:', error);
          return { events: [], spaces: [], pageInfo: {} };
        });

      collection.load(fetchPromise).then(data => {
        if (this.#currentFilters !== filters) return;

        this.#endCursor = data?.pageInfo?.endCursor || null;
        if (data?.pageInfo?.hasNextPage) {
          collection.showLoadMore();
        }

        if (!data?.events?.length) {
          this.#showSubscribeForm(filters.space);
        }
      });
    }

    #fetchMore() {
      if (!this.#endCursor) return;

      const collection = this.shadowRoot?.querySelector('spaces-event-collection');
      if (!collection || typeof collection.append !== 'function') return;

      const url = this.#buildUrl(this.#currentFilters);
      if (!url) return;
      url.searchParams.set('cursor', this.#endCursor);

      collection.hideLoadMore();

      const fetchPromise = fetch(url)
        .then(res => {
          if (!res.ok) throw new Error(`API error: ${res.status}`);
          return res.json();
        })
        .catch(error => {
          console.error('Failed to fetch more events:', error);
          return { events: [], spaces: [], pageInfo: {} };
        });

      collection.append(fetchPromise).then(data => {
        this.#endCursor = data?.pageInfo?.endCursor || null;
        if (data?.pageInfo?.hasNextPage) {
          collection.showLoadMore();
        }
      });
    }

    #showSubscribeForm(spaceFilter) {
      this.#hideSubscribeForms();
      const targetFilter = spaceFilter || 'all';
      const activeForm = this.querySelector(`.subscribe-form-wrapper[data-space-filter="${targetFilter}"]`);
      if (activeForm) activeForm.classList.add('active');
    }

    #hideSubscribeForms() {
      this.querySelectorAll('.subscribe-form-wrapper').forEach(form => {
        form.classList.remove('active');
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video-hero"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('spaces-video-hero')) {
  customElements.define('spaces-video-hero', class extends HTMLElement {
    #scrollPosition = null;

    connectedCallback() {
      if (!this.shadowRoot) {
        loadTemplateToShadowRoot(this);
      }

      this.video = this.shadowRoot?.querySelector('video');
      this.watchButton = this.shadowRoot?.querySelector('button');

      if (this.video) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.removeAttribute('autoplay');
          this.video.pause();
        } else {
          this.video.play().catch(() => {});
        }

        document.addEventListener('fullscreenchange', this.#onFullscreenChange);
        this.video.addEventListener('webkitendfullscreen', this.#onExitFullscreen);
      }

      this.watchButton?.addEventListener('click', this.#enterFullscreen);
    }

    disconnectedCallback() {
      document.removeEventListener('fullscreenchange', this.#onFullscreenChange);
      this.video?.removeEventListener('webkitendfullscreen', this.#onExitFullscreen);
    }

    #enterFullscreen = () => {
      if (!this.video) return;

      this.#scrollPosition = { x: window.scrollX, y: window.scrollY };

      if (this.video.requestFullscreen) {
        this.video.requestFullscreen().then(() => this.#unmute()).catch(() => {});
      } else if (this.video.webkitRequestFullscreen) {
        this.video.webkitRequestFullscreen();
        this.#unmute();
      } else if (this.video.webkitEnterFullscreen) {
        this.video.webkitEnterFullscreen();
        this.#unmute();
      }
    };

    #unmute() {
      if (!this.video) return;
      this.video.removeAttribute('muted');
      this.video.muted = false;
      this.video.volume = 1;
      this.video.play?.().catch(() => {});
    }

    #onFullscreenChange = () => {
      if (!this.video) return;

      const fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      // Safari can report the fullscreen element differently (e.g. the host), so treat
      // fullscreen as "anything in this component is fullscreen".
      const isFullscreen =
        !!fsEl &&
        (fsEl === this.video ||
          fsEl === this ||
          (this.shadowRoot && this.shadowRoot.contains(fsEl)));

      if (!isFullscreen) {
        this.#onExitFullscreen();
      }
    };

    #onExitFullscreen = () => {
      if (!this.video) return;

      this.video.muted = true;
      this.video.setAttribute('muted', '');
      this.video.play?.().catch(() => {});

      if (this.#scrollPosition) {
        const { x, y } = this.#scrollPosition;
        requestAnimationFrame(() => {
          if (window.scrollX !== x || window.scrollY !== y) {
            window.scrollTo(x, y);
          }
        });
      }
    };
  });
}
  } catch(e) { console.error(e); }
})();

})();
